// app/frontend/src/components/CustomDropdown.tsx
import { useState } from "react";

interface Language {
    code: string;
    label: string;
    flag: string;
}

interface CustomDropdownProps {
    languages: Language[];
    selectedCode: string;
    onSelect: (code: string) => void;
}

export default function CustomDropdown({ languages, selectedCode, onSelect }: CustomDropdownProps) {
    const [open, setOpen] = useState(false);
    const selectedLang = languages.find(lang => lang.code === selectedCode) || languages[0];

    return (
        <div className="relative inline-block text-left">
            <button
                type="button"
                onClick={() => setOpen(!open)}
                className="inline-flex items-center rounded border border-gray-300 bg-white px-3 py-1 text-sm font-medium shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
                <span className="mr-2">{selectedLang.flag}</span>
                {selectedLang.label}
                <svg className="ml-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            {open && (
                <ul className="absolute z-10 mt-1 w-full rounded bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                    {languages.map(lang => (
                        <li
                            key={lang.code}
                            className={`cursor-pointer px-4 py-2 text-sm hover:bg-blue-100 ${lang.code === selectedCode ? "bg-blue-50 font-semibold" : ""}`}
                            onClick={() => {
                                onSelect(lang.code);
                                setOpen(false);
                            }}
                        >
                            <span className="mr-2">{lang.flag}</span>
                            {lang.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
